"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgFullscreenOffOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.fullscreen-off_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "fullscreen-off_outline_svg__transparent_box" },
            React.createElement("path", { className: "fullscreen-off_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "fullscreen-off_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "fullscreen-off_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M27 11h-4.59l6.3-6.29-1.42-1.42L21 9.59V5h-2v8h8v-2zM27 21v-2h-8v8h2v-4.59l6.29 6.3 1.42-1.42-6.3-6.29H27zM11 9.59l-6.29-6.3-1.42 1.42L9.59 11H5v2h8V5h-2v4.59zM5 21h4.59l-6.3 6.29 1.42 1.42 6.29-6.3V27h2v-8H5v2z" }))));
}
exports.default = SvgFullscreenOffOutline;
//# sourceMappingURL=FullscreenOffOutline.js.map